import React from 'react'

import { Accordion, Box, Flex, Header, Icon, IconButton, Text, Tooltip } from '@driftt/dds'
import { faCircleInfo } from '@driftt/dds.icons/light/faCircleInfo'
import { faThumbsDown } from '@driftt/dds.icons/light/faThumbsDown'
import { faThumbsUp } from '@driftt/dds.icons/light/faThumbsUp'
import { faCircle } from '@driftt/dds.icons/solid/faCircle'
import { faSparkles } from '@driftt/dds.icons/solid/faSparkles'

import { useAIEngagementSummary } from 'hooks/useAIEngagementSummary'
import { ACCOUNT_RECOMMENDATION } from 'utils/bucketingUtil'

interface AIEngagementSummaryProps {
  accountId: string
  recommendation: ACCOUNT_RECOMMENDATION
}

const AIEngagementSummary = ({ accountId, recommendation }: AIEngagementSummaryProps) => {  

  const {
    showFeedback, 
    trackFeedback, 
    content, 
    headerCopy,
    tooltipCopy,
    feedbackCopy
  } = useAIEngagementSummary(accountId, 'Drawer')

  const header = 
    <Flex direction="row" justifyContent="space-between" alignItems="center">
      <Flex direction="row" alignItems="center">
        <Icon icon={faSparkles} color="purple7" />
        <Header variant="h3">{headerCopy}</Header>
        <Tooltip content={tooltipCopy} side="top">
          <Icon icon={faCircleInfo} />
        </Tooltip>
      </Flex>
    </Flex>
  
  const decorationColor = () => {
    switch(recommendation){
      case ACCOUNT_RECOMMENDATION.YES:
        return '$green6'
      case ACCOUNT_RECOMMENDATION.MAYBE:
        return '$yellow6'
      case ACCOUNT_RECOMMENDATION.NO:
        return '$red6'
    }
  }

  return (
    <Accordion.Item header={header} id="engagement-summary">
      <Flex direction='column' gap={2}>
        <Flex justifyContent='space-between' gap={8}>
          <Box>
            <Text variant='metadata'>Prospect?</Text>
            <Flex alignItems='center'>
              {recommendation !== ACCOUNT_RECOMMENDATION.UNKNOWN && 
                <Icon icon={faCircle} size='extra-small' css={{color: decorationColor()}}/>
              }
              <Text>{recommendation}</Text>
            </Flex>
          </Box>
          <Box>
            <Text variant='metadata'>Summary</Text>
            {content}
            {showFeedback && (
              <Flex direction="row" alignItems="center" gap="half">
                <Text variant="metadata">{feedbackCopy}</Text>
                <IconButton
                  icon={faThumbsUp}
                  title="It was useful"
                  size="small"
                  onClick={() => trackFeedback(true)}
                />
                <IconButton
                  icon={faThumbsDown}
                  title="It was not useful"
                  size="small"
                  onClick={() => trackFeedback(false)}
                />
              </Flex>
            )}
          </Box>
        </Flex>
      </Flex>
    </Accordion.Item>
  )
}

export default AIEngagementSummary
